import React from 'react'
import { Link } from 'react-router-dom'

export default function  Peas () {
    return <>
        <div className="container-fluid bg-primary py-5 bg-frzn10 mb-5">
            <div className="container py-5">
                <div className="row justify-content-start">
                    <div className="col-lg-8 text-center text-lg-start">
                        <h1 className="display-1 text-white mb-md-4">   Frozen Peas with Carrots

                        </h1>
                        <Link to="/frozen-products" className="btn btn-primary py-md-3 px-md-5 me-3">Frozen Products </Link>
                        <Link to="" className="btn btn-secondary py-md-3 px-md-5">   Frozen Peas with Carrots

                        </Link>
                    </div>
                </div>
            </div>
        </div>

        <div className="container py-5">
            <div className='mb-5'>
                <h2 className='text-primary'>   Frozen Peas with Carrots

                </h2>
                <h5 className='text-muted'>This blend of frozen peas and carrots is pre-washed, chopped, and flash-frozen 
to keep their freshness and nutritional content intact. It provides an easy way 
to enhance meals, free from any preservatives or chemicals.
 </h5>

            </div>

            <hr />
            <hr />

            <h2 className='text-primary my-3'>Packing</h2>

            <ul className='mb-5'>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 1 x 10 kg / carton 

                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 10 x 1 kg / carton 

                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>- 4 x 2.5 kg / carton 
                    </h5>

                </li>
                <li className="my-2">
                    <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'> - 20 x 400 g / carton 
                    </h5>

                </li>
            </ul>

            <hr />
            <hr />
            <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

        </div>
    </>
}
